import { Navigate, Outlet } from "react-router";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute() {
  const { user } = useAuth();

  if (user?.privilege !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}